import { FilterToolbarItemId } from 'src/components/Filters';
import { darkModeLightActiveOutline } from 'src/components/Reports/Reports.css';
import { Content, useContent } from 'src/contexts/ContentContext';
import { PosDropdown, PosDropdownItem } from 'src/core/POS/PosDropdown';
import { shared, vars } from 'src/core/themes';
import { Button, Stack } from 'src/core/ui';
import { EyeClosedIcon } from 'src/svgs/EyeClosedIcon';
import { EyeIcon } from 'src/svgs/EyeIcon';
import { EditIcon } from 'src/svgs/Viagogo';
import {
  REPORT_FILTER_EDITABILITY_TO_CID,
  REPORT_FILTER_EDITABILITY_TO_DESC_CID,
} from 'src/utils/constants/contentIdMaps';
import {
  DEFAULT_REPORT_FILTER_EDITABILITY,
  ReportFilterEditability,
} from 'src/utils/reportsFilterUtils';

const getEditabilityIcon = (
  reportFilterEditability: ReportFilterEditability,
  fill?: string
) => {
  switch (reportFilterEditability) {
    case ReportFilterEditability.Edit:
      return <EditIcon fill={fill} withHoverEffect darkModeLightHover />;
    case ReportFilterEditability.Hidden:
      return <EyeClosedIcon fill={fill} withHoverEffect darkModeLightHover />;
    case ReportFilterEditability.View:
      return <EyeIcon stroke={fill} withHoverEffect darkModeLightHover />;
  }
};

export const ReportFilterEditabilityDropdown = ({
  filterId,
  reportFilterEditability,
  onEditabilityChange,
  disabled,
}: {
  filterId: FilterToolbarItemId;
  reportFilterEditability?: ReportFilterEditability;
  onEditabilityChange: (
    filterId: FilterToolbarItemId,
    editability: ReportFilterEditability
  ) => void;
  disabled?: boolean;
}) => {
  const handleEditabilityChange = (editability: string) => {
    onEditabilityChange(filterId, editability as ReportFilterEditability);
  };

  const title = useContent(
    REPORT_FILTER_EDITABILITY_TO_DESC_CID[
      reportFilterEditability ?? DEFAULT_REPORT_FILTER_EDITABILITY
    ]
  );

  return (
    <PosDropdown
      key="report-filter-editability-dropdown"
      trigger={
        <Button
          variant="outline"
          title={title}
          disabled={disabled}
          style={{
            padding: vars.spacing.xs,
            borderRadius: vars.borderRadius.s,
            height: '100%',
            minWidth: '38px', // hardcoded to match the height of the filters
            minHeight: '38px',
          }}
          className={darkModeLightActiveOutline}
        >
          {getEditabilityIcon(
            reportFilterEditability ?? DEFAULT_REPORT_FILTER_EDITABILITY,
            disabled ? vars.color.textDisabled : vars.color.textBrand
          )}
        </Button>
      }
      triggerProps={{
        disabled: disabled,
      }}
      align="start"
    >
      {Object.values(ReportFilterEditability).map((editability) => (
        <PosDropdownItem
          key={editability}
          onClick={() => handleEditabilityChange(editability)}
        >
          <Stack gap="s" direction="column">
            <span
              style={
                editability ===
                (reportFilterEditability ?? DEFAULT_REPORT_FILTER_EDITABILITY)
                  ? { color: vars.color.textBrand }
                  : {}
              }
            >
              <Content id={REPORT_FILTER_EDITABILITY_TO_CID[editability]} />
            </span>
            <span className={shared.typography.body2}>
              <Content
                id={REPORT_FILTER_EDITABILITY_TO_DESC_CID[editability]}
              />
            </span>
          </Stack>
        </PosDropdownItem>
      ))}
    </PosDropdown>
  );
};
